import { useEffect } from "react";
import {
  useLocation,
  useParams,
} from "react-router-dom";

export default function RecoveryPageRedirect() {
  const { lang } = useParams();
  const location = useLocation();

  const language = lang === "sl" ? "sl" : "en";

  const page = location.pathname.endsWith(
    "/reset-password"
  )
    ? "reset-password"
    : "forgot-password";

  useEffect(() => {
    window.location.replace(
      `https://www.revimo.eu/${language}/${page}` +
      location.search +
      location.hash
    );
  }, [
    language,
    page,
    location.search,
    location.hash,
  ]);

  return (
    <p>
      {language === "sl"
        ? "Odpiranje strani za obnovitev gesla…"
        : "Opening account recovery…"}
    </p>
  );
}